import { render, staticRenderFns } from "./ResultTrend.vue?vue&type=template&id=a8445188&scoped=true&"
import script from "./ResultTrend.vue?vue&type=script&lang=js&"
export * from "./ResultTrend.vue?vue&type=script&lang=js&"
import style0 from "./ResultTrend.vue?vue&type=style&index=0&id=a8445188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8445188",
  null
  
)

export default component.exports